<app-pagetitle title="{{nameApp}}" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>
<div class="row">
    <div class="col-sm-12">
        <div class="card card-border">
            <div class="card-header">
                <div class="row">
                    <div class="col-sm-6 text-sm-right">
                      <div  *ngIf="verifyIfNotActivePlan(dataApp); else message">  <button *hasPermission="{app: constant.PLAN_INSTITUCIONAL, permission: [constant.CREAR]}"  type="button"
                        class="btn btn-sm btn-success waves-effect" (click)="openModal()"><i
                            class="fas fa-plus fa-lg mr-1"></i> Nuevo</button></div>

                        <ng-template #message>
                            <span>Para poder agregar un nuevo plan, debe desactivar todos!</span>
                        </ng-template>
                    </div>
                </div>
            </div>

            <div class="container card-body t able-responsive">
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                    class="table table-striped table-bordered row-border hover">
                    <thead>
                        <tr>
                            <th>Nro.</th>
                            <th>Nombre</th>
                            <th>Fecha inicio</th>
                            <th>Fecha fin</th>
                            <th>Estado</th>
                            <th *hasPermission="{app: constant.PLAN_INSTITUCIONAL, permission: [constant.ACTUALIZAR, constant.BORRAR]}">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of dataApp; let indice=index">
                            <td>{{indice+1}}</td>
                            <td>{{row.nombre}}</td>
                            <td>{{row.fechaInicio | date: 'dd-MM-yyyy'}}</td>
                            <td>{{row.fechaFin | date: 'dd-MM-yyyy'}}</td>
                            <td>{{((row.estado == '1')? 'Activo': 'Inactivo')}}</td>
                            <td *hasPermission="{app: constant.PLAN_INSTITUCIONAL, permission: [constant.ACTUALIZAR, constant.BORRAR]}"  class="text-center">
                                <div class="row">
                                    <button *hasPermission="{app: constant.PLAN_INSTITUCIONAL, permission: [constant.ACTUALIZAR]}" type="button" tooltip="Editar"
                                        class="btn btn-sm btn-link waves-effect rounded-pill col px-0"
                                        title="Editar este registro" (click)="edit(row)">
                                        <i class="fas fa-pencil-alt fa-lg"></i>
                                    </button>
                                    <button *hasPermission="{app: constant.PLAN_INSTITUCIONAL, permission: [constant.BORRAR]}" type="button" class="btn btn-sm btn-link waves-effect col px-0"
                                        title="Eliminar este registro" (click)="delete(row.idSprPlanInstitucional)">
                                        <i class="fas fa-trash-alt fa-lg"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<jw-modal id="delete">
    <div class="modal-dialog" style="padding-top:15%">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myCenterModalLabel">Advertencia!</h4>
                <button type="button" class="btn-close" (click)="modal.close()"></button>
            </div>
            <div class="modal-body">
                <p class="pl-4"><i class="pl-2 fas fa-exclamation-circle text-warning  fa-lg fa-2x"></i>&nbsp;
                    &nbsp; Esta seguro que desea eliminar este registro? </p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary waves-effect" (click)="modal.close();">Cerrar</button>
                <button type="button" class="btn btn-primary" (click)="confirmDelete()">Si, borrar!</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</jw-modal>

<jw-modal id="{{nameModal}}">
    <!-- MODAL PARA CREAR Y EDITAR -->

    <div class="modal-dialog modal-lg modal-dialog-scrollable" style="padding-top:6%">
        <div class="modal-content">
            <div class="modal-header pb-3">
                <h3 class="modal-title">{{nameApp}}</h3>
                <button type="button" class="btn-close" (click)="modal.close();" aria-label="Close"></button>
            </div>
            <div class="modal-body pT-4">
                <form class="needs-validation" novalidate id="formPlanInstitucional"
                    [formGroup]="formPlanInstitucional">
                    <div class="row">
                        <input type="hidden" id="idSprPlanInstitucional" formControlName="idSprPlanInstitucional">
                        <div>

                            <div class="form-floating mb-3">
                                <input id="idSprPlanInstitucional" type="text" class="form-control" required="true"
                                    formControlName="nombre"

                                    [ngClass]="{
                                      'is-invalid': this.formPlanInstitucional.get('nombre')?.errors && this.submitted,
                                      'is-valid': !this.formPlanInstitucional.get('nombre')?.errors,
                                    }" />
                                <label for="nombre">Nombre</label>
                                <small class="invalid-feedback"
                                    *ngIf="this.formPlanInstitucional.get('nombre')?.errors?.['required'] && this.submitted">Campo
                                    requerido</small>

                            </div>
                        </div>
                    </div>
                    <div class="form-floating mb-3">

                        <textarea  id="mision" type="text" style= "height: 141px;" class="form-control"  required="true"
                            formControlName="mision" rows="10" cols="30"
                            maxlength="1000" [ngClass]="{
                                    'is-invalid': this.formPlanInstitucional.get('mision')?.errors && this.submitted,
                                    'is-valid': !this.formPlanInstitucional.get('mision')?.errors,
                                  }">
                                </textarea>
                        <label for="mision">Misión</label>
                        <small class="invalid-feedback"
                            *ngIf="this.formPlanInstitucional.get('mision')?.errors?.['required'] && this.submitted">Campo
                            requerido</small>

                    </div>
                    <div class="form-floating mb-3">

                        <textarea  id="vision" type="text" style= "height: 141px;" class="form-control"  required="true"
                            required="true" formControlName="vision"
                            maxlength="1000" [ngClass]="{
                                    'is-invalid': this.formPlanInstitucional.get('vision')?.errors && this.submitted,
                                    'is-valid': !this.formPlanInstitucional.get('vision')?.errors,}">
                                  </textarea>
                        <label for="vision">Visión</label>
                        <small class="invalid-feedback"
                            *ngIf="this.formPlanInstitucional.get('vision')?.errors?.['required'] && this.submitted">Campo
                            requerido</small>

                    </div>
                    <div class="form-group mb-3 row">
                        <div class="form-floating mb-3 col-md-6">
                            <input type="date" id="fechaInicio" class="form-control" formControlName="fechaInicio"  (change)="controlFechasAnios()"
                                required autofocus placeholder="fechaInicio" date>
                            <!-- (change)="onSelectInitialDate()" -->

                            <!--  -->

                            <small class="invalid-feedback" *ngIf="submitted && rolForm['fechaInicio'].errors">Campo
                                requerido</small>
                            <label for="fechaInicio">Fecha Inicio</label>
                        </div>


                        <div class="form-floating mb-3 col-md-6">

                            <input type="date" class="form-control" formControlName="fechaFin" required autofocus
                                placeholder="fechaFin" date>

                            <small class="invalid-feedback" *ngIf="submitted && rolForm['fechaFin'].errors">Campo
                                requerido.</small>
                            <label for="fechaFin">Fecha fin</label>
                        </div>
                    </div>

                    <div class="form-floating mb-3">
                        <div class="col col-md-2 text-md-right ">
                        </div>
                        <div class="form-floating mb-3">
                            <select id="estado" class="form-select" formControlName="estado" required="true" [ngClass]="{
                        'is-invalid': this.formPlanInstitucional.get('estado')?.errors && this.submitted,
                        'is-valid': !this.formPlanInstitucional.get('estado')?.errors, }">
                                <option value="1" selected>Activo</option>
                                <option value="2">Inactivo</option>
                            </select>
                            <small class="invalid-feedback"
                                *ngIf="this.formPlanInstitucional.get('estado')?.errors?.['required'] && this.submitted">Campo
                                requerido</small>
                            <label for="fechaFin">Estado</label>
                        </div>
                    </div>

                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary waves-effect" (click)="modal.close();">Cerrar</button>
                <button type="button" class="btn btn-info" (click)="onSubmit()">Guardar</button>
            </div>
        </div>
    </div>
</jw-modal>
